<template>
  <div class="header_wrap">
    <div class="container">
      <div class="header_left">
        <img class="logo" src="@/assets/image/logo.png" @click="goHome()" />
        <el-cascader :options="options" clearable :placeholder="value" v-model="values" @change="handleChange"></el-cascader>
      </div>

      <nav>
        <ul>
          <li v-for="(item, index) in navs" :key="index" @click="changeActive(item)" :class="{ 'nav-active': item.active }">
            <a v-if="item.outlink" :href="item.path" target="_blank">
              <img :src="item.active? item.iconActive: item.icon" alt="" />
              <span>{{ item.title }}</span>
              <aside v-if="item.num">{{ item.num }}</aside>
            </a>
            <router-link :to="item.path" v-else>
              <img :src="item.active? item.iconActive: item.icon" alt="" />
              <span>{{ item.title }}</span>
              <aside v-if="item.num">{{ item.num }}</aside>
            </router-link>
          </li>
        </ul>
      </nav>

      <div class="msg_box">
        <img src="@/assets/image/icon_msg.png" alt="" />
        <aside v-if="msgNum">{{ msgNum }}</aside>
      </div>
      <div class="header_right">
        <p> {{ userInfo.mobile }} </p>

        <el-popover placement="bottom" width="150" trigger="hover">
          <div style="display: flex; align-items: center; padding: 10px 0;cursor: pointer;" @click="personal">
            <img src="../../assets/image/个人中心.png" alt="" />
            <span>个人中心</span>
          </div>

          <div style="display: flex; align-items: center; padding: 10px 0;cursor: pointer;" @click="switchs">
            <img src="../../assets/image/切换身份.png" alt="" />
            <span>切换身份</span>
          </div>

          <div style="display: flex; align-items: center; padding: 10px 0;cursor: pointer;" @click="exitlogins">
            <img src="../../assets/image/login_out.png" alt="" />
            <span>退出登录</span>
          </div>

          <img class="avatars" slot="reference" :src="userInfo.user_avatar" />
        </el-popover>
      </div>

    </div>

  </div>
</template>

<script>
// 引入接口
import { exitlogin, districtslist } from "@/api/login/login";
// 引入静态图片
import work_1 from '@/assets/image/work_1.png'
import work_2 from '@/assets/image/work_2.png'
import person_1 from '@/assets/image/person_1.png'
import person_2 from '@/assets/image/person_2.png'
import chat_1 from '@/assets/image/chat_1.png'
import chat_2 from '@/assets/image/chat_2.png'
import serve_1 from '@/assets/image/serve_1.png'
import serve_2 from '@/assets/image/serve_2.png'
import relation_1 from '@/assets/image/relation_1.png'
import relation_2 from '@/assets/image/relation_2.png'
import company_1 from '@/assets/image/company_1.png'
import company_2 from '@/assets/image/company_2.png'
import team_1 from '@/assets/image/team_1.png'
import team_2 from '@/assets/image/team_2.png'
import default_avatar from '@/assets/image/avatar.png'

import { mapGetters } from 'vuex'


export default {
  data () {
    return {
      values: [],
      value: "",
      typevalue: "",
      activeIndex: "0",
      navs: [
        {
          title: "",
          name: '',
          path: '',
          icon: '',
          iconActive: '',
          num: 0,
          active: false,
          outlink:false,
        },
      ],
      directorNavs: [//主管端导航
        {
          title: "工作台",
          name: 'director-work',
          path: '/director-work',
          icon: work_1,
          iconActive: work_2,
          num: 0,
          active: false,
          outlink:false,
        },
        {
          title: "找人才",
          name: 'director-talent',
          path: '/director-talent',
          icon: person_1,
          iconActive: person_2,
          num: 0,
          active: false,
          outlink:false,
        },
       /* {
          title: "聊呗",
          name: 'director-chat',
          path: '/director-chat',
          icon: chat_1,
          iconActive: chat_2,
          num: 0,
          active: false,
          outlink:false,
        },*/
        {
          title: "聊呗",
          name: 'chat',
          path: '/chat',
          icon: chat_1,
          iconActive: chat_2,
          num: 0,
          active: false,
          outlink:false,
        },
        {
          title: "人脉圈",
          name: 'relation',
          path: '/relation',
          icon: relation_1,
          iconActive: relation_2,
          num: 9,
          active: false,
          outlink:false,
        },

       /* {
          title: "客服",
          name: 'director-chat-service',
          path: '/director-chat-service',
          icon: serve_1,
          iconActive: serve_2,
          num: 0,
          active: false,
          outlink:false,
        },*/

        {
          title: "客服",
          name: 'chat-service',
          path: '/chat-service',
          icon: serve_1,
          iconActive: serve_2,
          num: 0,
          active: false,
          outlink:false,
        },

        {
          title: "企业入口",
          name: 'http://jianzhibei.company.yuan1024.cn/#/login',
          path: 'http://jianzhibei.company.yuan1024.cn/#/login',
          icon: company_1,
          iconActive: company_2,
          outlink:true,
          num: 0,
          active: false
        },
        {
          title: "团队登录",
          name: 'http://jianzhibei.shetuan.yuan1024.cn/#/login',
          path: 'http://jianzhibei.shetuan.yuan1024.cn/#/login',
          icon: team_1,
          iconActive: team_2,
          outlink:true,
          num: 0,
          active: false
        },

      ],

      personalNavs: [//求职端导航
        {
          title: "工作台",
          name: 'personal-work',
          path: '/personal-work',
          icon: work_1,
          iconActive: work_2,
          num: 0,
          outlink:false,
          active: false
        },
        {
          title: "找职位",
          name: 'personal-job',
          path: '/personal-job',
          icon: person_1,
          iconActive: person_2,
          num: 0,
          outlink:false,
          active: false
        },
        /*{
          title: "聊呗",
          name: 'personal-chat',
          path: '/personal-chat',
          icon: chat_1,
          iconActive: chat_2,
          num: 0,
          outlink:false,
          active: false
        },*/

        {
          title: "聊呗",
          name: 'chat',
          path: '/chat',
          icon: chat_1,
          iconActive: chat_2,
          num: 0,
          outlink:false,
          active: false
        },
        {
          title: "人脉圈",
          name: 'relation',
          path: '/relation',
          icon: relation_1,
          iconActive: relation_2,
          num: 0,
          outlink:false,
          active: false
        },

       /* {
          title: "客服",
          name: 'personal-chat-service',
          path: '/personal-chat-service',

          icon: serve_1,
          iconActive: serve_2,
          num: 0,
          outlink:false,
          active: false
        },*/
        {
          title: "客服",
          name: 'chat-service',
          path: '/chat-service',

          icon: serve_1,
          iconActive: serve_2,
          num: 0,
          outlink:false,
          active: false
        },

        {
          title: "团队登录",
          name: 'http://jianzhibei.shetuan.yuan1024.cn/#/login',
          path: 'http://jianzhibei.shetuan.yuan1024.cn/#/login',

          icon: team_1,
          iconActive: team_2,
          num: 0,
          outlink:true,
          active: false
        },

      ],


      auditionNav: [
        {
          title: "面试宝",
          name: 'director-audition',
          path: '/director-audition',

          icon: team_1,
          iconActive: team_2,
          num: 0,
          outlink:false,
          active: false
        },
      ],

      payNav: [
        {
          title: "企业端主管支付",
          name: 'director-pay',
          path: '/director-pay',

          icon: team_1,
          iconActive: team_2,
          num: 0,
          outlink:false,
          active: false
        },
      ],


      masterNav: [
        {
          title: "工作通",
          name: 'director-workmaster',
          path: '/director-workmaster',

          icon: team_1,
          iconActive: team_2,
          num: 0,
          outlink:false,
          active: false
        },
      ],
      



      options: [],
      citylist: [],
      msgNum: 9
    };
  },


  computed: {
    ...mapGetters([
      //'userInfo',
     // 'isLogin',
      'user_type'// 1 求职 2 招聘
    ]),
  },



  created () {
    this.userInfo= JSON.parse(localStorage.getItem('userInfo'));

    // this.changeActive();
    this.initNav();

    this.getcity();
  },
  mounted () {
    this.getLocation();
  },


  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.initNav();
      },
      // 深度观察监听
      deep: true
    },
    "$store.state.user.user_type": {
      //深度监听设置为
      deep: true,//
      handler: function (newVal, oldVal) {
        //修改数据时，能看到输出结果
        console.log(oldVal, newVal);
        this.initNav();

      }
    }
  },


  methods: {

    initNav () {
      this.userInfo= JSON.parse(localStorage.getItem('userInfo'));
      if (this.user_type == 1) {
        this.navs = this.personalNavs;
      } else {
        if (this.$route.path.includes("director-audition")) {
          this.navs = this.auditionNav;

        } else if (this.$route.path.includes("director-pay")) {
          this.navs = this.payNav;//         

        } else if (this.$route.path.includes("director-workmaster")) {
          this.navs = this.masterNav;//          

        } else {
          this.navs = this.directorNavs;
        }

      }

      var has=false;
      this.navs.forEach((item) => {
        if(item.path == this.$route.path){
          item.active=true;
          has=true;
          //continue;
        }else {
           item.active=false;
         
        }
       // item.active = (item.path == this.$route.path || this.$route.path.includes(item.name) ? true : false);
      });

      if(has==false){
        this.navs.forEach((item) => {
         item.active = (item.path == this.$route.path || this.$route.path.includes(item.name) ? true : false);

      });
      }

    },


    changeActive (nav) {
      var that = this;

      this.navs.forEach((item) => {
        if (item.path == nav.path) {
          console.log(item.path)
          item.active = true;
        } else {
          item.active = false;
        }

      });
    },


    goHome () {
      this.$router.push({ name: "index" });
    },
    homes () {
      this.$router.push({ name: "Home" });
    },
    //定位当前位置
    getLocation () {
      if (!window.qq || !window.qq.maps) {
        return;
      }
      var geolocation = new window.qq.maps.Geolocation(
        "EYFBZ-4BKW6-HYVS7-EEFUP-QRAH5-7LBBX",
        "referer-jianzhibei"
      );
      geolocation.getLocation(this.showPosition, this.errorPosition);
    },
    showPosition (position) {
      console.log(position);
      this.value = position.city;
    },
    errorPosition () {
      console.log("定位失败");
      //继续定位
      this.getLocation();
    },
    switchs () {
      if (this.user_type == 1) {
        this.$router.push({ name: "change-status" });
      }
      if (this.user_type == 2) {
        this.$router.push({ name: "change-status" });
      }
    },
    //个人中心
    personal () {
      this.$router.push({ name: "member-center" });
    },
    handleChange (value) {

    },

    getcity () {
      districtslist().then((res) => {
        this.options = res.data;
      });
    },

    exitlogins () {
      let data = {};
      exitlogin(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("退出成功");
          //清除token
          localStorage.removeItem("token");
          //跳转
          this.$router.push({ name: "login" });
        }
      });
    },
  },
  components: {},
};
</script>

<style lang='scss' scoped>
.header_wrap {
  background-color: #4c71db;
  height: 64px;
  .container {
    height: 64px;
    display: flex;
    justify-content: space-between;
    .header_left {
      display: flex;
      align-items: center;
      .logo {
        width: 101px;
      }
    }
    nav ul {
      min-width: 650px;
      display: flex;
      a {
        position: relative;
        padding: 0 15px;
        line-height: 64px;
        display: flex;
        align-items: center;
        color: #ffffff;
        font-size: 16px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    .msg_box {
      margin-left: 20px;
      padding: 0 20px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 18px;
      }
    }
    .header_right {
      display: flex;
      align-items: center;
      font-size: 16px;
      p {
        color: #ccc;
      }
      img {
        margin-left: 24px;
        width: 34px;
        height: 34px;
        border-radius: 17px;
      }
    }
    aside {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 2px;
      right: 0;
      color: #fff;
      background-color: #ff4e4e;
      border-radius: 10px;
      line-height: 20px;
      font-size: 12px;
      text-align: center;
    }
  }
}

::v-deep .el-menu-item.is-active {
  color: white !important;
  background-color: #4c71db !important;
}
::v-deep .el-cascader .el-input {
  width: 90px;
  border: none !important;
  margin-right: 20px;
}
::v-deep .el-cascader .el-input .el-input__inner {
  color: white;
  border: none;
  background-color: transparent;
}
::v-deep .el-popover {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.nav-active {
  background: #2E437E;
}
</style>
